import { createReducer, on } from '@ngrx/store';

import { TwoFaClient } from '../model/twofa-client.model';
import { AppState } from './app.state';
import {
  delete2faClientPwd,
  generated2faClientPwd,
  retrieved2faClientStatus,
  retrievedPasswordExpirationConfig,
  retrievedTwoFaInfos,
  retrievedWebMailClientUrl,
  retrieveduserInfoPecPlus,
  updatePasswordExpirationConfig,
  updateTwoFaInfos,
  updateUserLanguage,
  userLoggedin,
  retrieved2faClientThirdPartsGrants,
  retrievedOtpDisplayAvailable,
} from './user.actions';

export const initialAppState: AppState = {
  currentUser: null,
  passwordExpirationConfig: null,
  pswExpirationConfigLoaded: false,
  twoFaDevice: null,
  twoFaEnabled: null,
  twoFaEnabledLoaded: false,
  twoFaClientStatus: null,
  webMailClientUrl: '',
  userInfoPecPlus: null,
  clientThirdPartsGrants: null,
  otpDisplayAvailable: false,
};

export const appReducer = createReducer(
  initialAppState,
  on(userLoggedin, (state, { user }) => ({ ...state, currentUser: user })),
  on(updateUserLanguage, (state, { lang }) => {
    const newUser = Object.assign({}, state.currentUser);
    if (newUser) {
      newUser.lang = lang;
    }
    return {
      ...state,
      currentUser: newUser,
    };
  }),
  on(retrievedPasswordExpirationConfig, (state, { expiryConfig }) => ({
    ...state,
    passwordExpirationConfig: expiryConfig,
    pswExpirationConfigLoaded: true,
  })),
  on(updatePasswordExpirationConfig, (state, { expiryConfig }) => ({ ...state, passwordExpirationConfig: expiryConfig })),
  on(retrievedTwoFaInfos, (state, { status, device }) => ({
    ...state,
    twoFaEnabled: status,
    twoFaEnabledLoaded: true,
    twoFaDevice: device ?? null,
  })),
  on(updateTwoFaInfos, (state, { status, device }) => ({ ...state, twoFaEnabled: status, twoFaDevice: device ?? null })),
  on(retrieved2faClientStatus, (state, { twoFaClientStatus }) => {
    return { ...state, twoFaClientStatus };
  }),
  on(generated2faClientPwd, (state, { twoFaClient }) => {
    if (twoFaClient === null) {
      return { ...state, twoFaClientStatus: new TwoFaClient(false, true) };
    }

    const newTwoFaClient = new TwoFaClient(true, twoFaClient.hasActiveProtocol, twoFaClient.expireTs, twoFaClient.createTs);
    return { ...state, twoFaClientStatus: newTwoFaClient };
  }),
  on(delete2faClientPwd, state => {
    const new2faClient = new TwoFaClient(false, !!state.twoFaClientStatus?.hasActiveProtocol);
    return { ...state, twoFaClientStatus: new2faClient };
  }),
  on(retrievedWebMailClientUrl, (state, { webMailClientUrl }) => {
    return { ...state, webMailClientUrl };
  }),
  on(retrieveduserInfoPecPlus, (state, { userInfoPecPlus }) => {
    return { ...state, userInfoPecPlus };
  }),
  on(retrieved2faClientThirdPartsGrants, (state, { clientThirdPartsGrants }) => {
    return { ...state, clientThirdPartsGrants };
  }),
  on(retrievedOtpDisplayAvailable, (state, { otpDisplayAvailable }) => {
    return { ...state, otpDisplayAvailable };
  })
);
